import React from 'react';
import { motion } from 'framer-motion';
export function SlideTitle() {
  return <div className="h-full w-full bg-[#1B4F72] text-white flex flex-col justify-between p-12 md:p-24 relative overflow-hidden" data-id="element-523">
      {/* Nubeqa brand background image with diagonal clip */}
      <div className="absolute inset-0 w-full h-full pointer-events-none" style={{
      clipPath: 'polygon(0 0, 55% 0, 45% 100%, 0 100%)'
    }} data-id="element-524">
        <img src="https://cdn.magicpatterns.com/uploads/xA3Tdad3JJonYTdDgxUArY/Screenshot_2026-02-12_at_08.06.01.png" alt="" className="w-full h-full object-cover opacity-60" data-id="element-525" />
      </div>

      {/* Background decoration - angular gradient */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-gradient-to-l from-[#5B8FAF]/20 to-transparent pointer-events-none" data-id="element-526" />

      {/* Diagonal accent line */}
      <div className="absolute top-0 left-[45%] w-1 h-full bg-gradient-to-b from-[#7CB9D8] via-[#5B8FAF] to-[#1B4F72] pointer-events-none opacity-60" style={{
      transform: 'skewX(-15deg)'
    }} data-id="element-527" />

      {/* Main Content */}
      <main className="flex-1 flex flex-col justify-center z-10 max-w-[55%]" data-id="element-528">
        <motion.h1 className="text-5xl md:text-7xl font-bold leading-tight mb-6" initial={{
        opacity: 0,
        x: -50
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} data-id="element-529">
          Snakker™ for <br data-id="element-530" />
          <span className="text-[#7CB9D8]" data-id="element-531">Pharma Congresses</span>
        </motion.h1>

        <motion.div className="h-1 w-32 bg-gradient-to-r from-[#5B8FAF] to-[#7CB9D8] mb-8" initial={{
        width: 0
      }} animate={{
        width: 128
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} data-id="element-532" />

        <motion.p className="text-2xl text-gray-300 font-light" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.8,
        delay: 0.8
      }} data-id="element-533">
          Full Journey Activation – From Awareness to Action
        </motion.p>
      </main>

      {/* Footer Hint */}
      <motion.footer className="flex items-center gap-2 text-gray-400 text-sm z-10" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.5,
      duration: 1
    }} data-id="element-534">
        <span data-id="element-535">Press</span>
        <div className="px-2 py-1 border border-gray-600 rounded bg-white/5 font-mono text-xs" data-id="element-536">
          →
        </div>
        <span data-id="element-537">to begin</span>
      </motion.footer>
    </div>;
}